import {
  PriceChangeItem,
  PriceChangeQuery,
  PriceChangeResponse,
} from '../Model/priceChangeXModel'
import { cashReconciliationBXService } from './cashReconciliationBXService'
import { formatReportDate } from '../Utils/stationOperations'

export const priceChangeBXService = {
  list: async (query: PriceChangeQuery): Promise<PriceChangeResponse> => {
    const response = await cashReconciliationBXService.listPriceChanges(query)
    return {
      data: (response.data.data ?? []).map((change): PriceChangeItem => ({
        id: change.resourceId,
        reportId: change.reportResourceId,
        station: change.stationName || change.stationId,
        product: change.product,
        pump: change.pumpLabel,
        totalizerReading: change.totalizerReading,
        newPriceMinor: change.newPriceMinor,
        // The API's clock time is synthetic; only the business date is meaningful.
        effectiveFrom: formatReportDate(change.reportDate),
      })),
      total: response.data.meta?.total ?? response.data.data?.length ?? 0,
      page: response.data.meta?.page ?? query.page,
      limit: response.data.meta?.limit ?? query.limit,
    }
  },
}
